import { useState, useEffect } from 'react';
import axios from 'axios';

const API = '';

export default function useCompanyStats() {
  const [stats, setStats] = useState({
    cnc_total: "31+",
    lathes_total: "9",
    lathes_live_tool: "6",
    lathes_roughing: "3",
    lathes_five_axis: "4",
    facility_size: "77K",
    facility_size_full: "77,000+",
    cleanroom_size: "2,500",
    clean_work_area: "800",
    year_founded: "2004"
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    axios.get(`${API}/api/company-stats`)
      .then(res => {
        if (active && res.data) {
          setStats(res.data);
          setLoading(false);
        }
      })
      .catch(err => {
        console.error('Error fetching company stats:', err);
        if (active) {
          setError(err);
          setLoading(false);
        }
      });
    return () => {
      active = false;
    };
  }, []);

  return { stats, loading, error };
}
